export default "__VITE_ASSET__DGsXzZyw__"